<template>
  <q-page
    class="static q-mb-xl"
    dir="ltr"
  >
    <section class="container q-px-md no-rtl">
      <div class="row justify-center">
        <div class="col-md-8">
          <h1 class="text-black">{{ content.h1 }}</h1>
          <p class="text-uppercase">{{ $t('label.whereas') }}:</p>
          <ul>
            <li
              v-for="(item, index) in content.whereas"
              :key="index"
            >
              {{ item }},
            </li>
          </ul>
          <p>{{ content.subwhereas }}</p>
          <p>{{ content.use_of }}</p>
          <div
            v-for="subitem in content.subitems"
            :key="subitem.h3"
          >
            <h3 class="text-black">
              {{ subitem.h3 }}
            </h3>
            <p
              v-for="item in subitem.items"
              :key="item"
              class="terms-item q-my-md text-justify"
              v-html="item"
            />
          </div>
        </div>
      </div>
    </section>
  </q-page>
</template>

<script>
export default {
  name: 'PartnershipAgreement',
  data() {
    return {
      content: this.$t('pages.partnership_agreement'),
    };
  },
};
</script>
